import { Pivot, PivotItem, PivotLinkSize } from "@fluentui/react";
import React, { createContext, useContext } from "react";
import { EbendoDailySettings } from "./EbendoDailySettings";
import { NaocFlashProductionSettings } from "../daily-templates/NaocFlashProductionSettings";
import { InputDeckSettings } from "../monthly-templates/InputDeckSettings";
import SettingStore from "../store/settingstore";
import { observer } from "mobx-react-lite";
import { QuaiboDailySettings } from "./QuaiboDailySettings";
const settingStorectx = createContext(SettingStore);
export const DailyProductionTabs = observer(() => {
  //const [itemKey, setItemKey] = useState("1");
  const settingStore = useContext(settingStorectx);
  return (
    <Pivot
      linkSize={PivotLinkSize.normal}
      selectedKey={settingStore.dailyProdTabSelKey}
      onLinkClick={(item, ev) => {
        settingStore.dailyProdTabSelKey = item.props.itemKey;
      }}
    >
      <PivotItem headerText="NAOC Daily Flash Input Deck" itemKey="1">
        <NaocFlashProductionSettings />
      </PivotItem>

      <PivotItem headerText="EBENDO Field Input Deck " itemKey="2">
        <EbendoDailySettings />
      </PivotItem>
      <PivotItem headerText="QUA IBO Field Input Deck " itemKey="3">
        <QuaiboDailySettings />
      </PivotItem>

      <PivotItem headerText="Well/String Input Deck " itemKey="4">
        <InputDeckSettings />
      </PivotItem>
    </Pivot>
  );
});

